import { render, staticRenderFns } from "./generalSettings.vue?vue&type=template&id=54512b7f&scoped=true&"
import script from "./generalSettings.vue?vue&type=script&lang=js&"
export * from "./generalSettings.vue?vue&type=script&lang=js&"
import style0 from "./generalSettings.vue?vue&type=style&index=0&id=54512b7f&scoped=true&lang=scss&"
import style1 from "./generalSettings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54512b7f",
  null
  
)

export default component.exports